<!--
 * @Description: 教职工详情 奖励
 * @Author: 张天伟
 * @Date: 2023-03-08 17:09:21
 * @LastEditors: PF
 * @LastEditTime: 2024-10-15 16:47:38
-->

<template>
  <div>
    <el-descriptions class="descript-box" v-for="(item, index) in tableData" :key="index" :column="4" border>
      <el-descriptions-item label="获奖项目" label-align="right" align="left" width="100px" span="2">{{item.hjxm}}</el-descriptions-item>
      <el-descriptions-item label="奖励级别" label-align="right" align="left" width="100px" span="2">{{item.jljbbt}}</el-descriptions-item>
      <el-descriptions-item label="奖励等级" label-align="right" align="left" width="100px" span="2">{{item.jldjbt}}</el-descriptions-item>
      <el-descriptions-item label="获奖类别" label-align="right" align="left" width="100px" span="2">{{item.hjlbbt}}</el-descriptions-item>
      <el-descriptions-item label="奖励方式" label-align="right" align="left" width="100px" span="2">{{item.jlfsbt}}</el-descriptions-item>
      <el-descriptions-item label="奖励名称" label-align="right" align="left" width="100px" span="2">{{item.jlmc}}</el-descriptions-item>
      <el-descriptions-item label="奖励名称" label-align="right" align="left" width="100px" span="2">{{item.jlmcbt}}</el-descriptions-item>
      <el-descriptions-item label="获奖原因" label-align="right" align="left" width="100px" span="2">{{item.hjyy}}</el-descriptions-item>
      <el-descriptions-item label="奖励内容" label-align="right" align="left" width="100px" span="2">{{item.jlnr}}</el-descriptions-item>
      <el-descriptions-item label="颁奖单位" label-align="right" align="left" width="100px" span="2">{{item.bjdw}}</el-descriptions-item>
      <el-descriptions-item label="获奖日期" label-align="right" align="left" width="100px" span="2">{{item.hjrq}}</el-descriptions-item>
      <el-descriptions-item label="荣誉称号" label-align="right" align="left" width="100px" span="2">{{item.rych}}</el-descriptions-item>
      <el-descriptions-item label="获奖角色" label-align="right" align="left" width="100px" span="4">{{item.hjjs}}</el-descriptions-item>
      <el-descriptions-item label="" label-align="right" align="left" span="4"></el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'
import { actionPost } from '@/api/common.js'

const props = defineProps({ row: { type: Object, required: false } })
const tableData = ref()

watch(
  () => props.row,
  () => {
    if (props.row) {
      const o = {
        url: '/api/v2/renliziyuan/jiaozhigongjiangli/list',
        data: { id: props.row.id, order: 'gh', sort: 'asc' }
      }
      actionPost(o).then((res) => {
        tableData.value = res.data
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
